var React = require('react');

function Burger (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M224 128a8 8 0 0 1-8 8H40a8 8 0 1 1 0-16h176a8 8 0 0 1 8 8zM86 72h132c3.314 0 6-3.582 6-8s-2.686-8-6-8H86c-3.314 0-6 3.582-6 8s2.686 8 6 8zm132 112H86c-3.314 0-6 3.582-6 8s2.686 8 6 8h132c3.314 0 6-3.582 6-8s-2.686-8-6-8z"}));
}

Burger.defaultProps = {"width":"32","height":"32","viewBox":"0 0 256 256"};

module.exports = Burger;

Burger.default = Burger;
